exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".short-input {\n  width: 100px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/app/datepicker/datepicker.component.css
// module id = 363
// module chunks = 2